import shiftRequestDetailsStore from "../../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_USER_RESPONSE_MESSAGE', function setUserResponseMessageInStore(userResponseMessage: string) {
    if (shiftRequestDetailsStore) {
        shiftRequestDetailsStore.userResponseMessage = userResponseMessage;
    }
});